module.exports = __webpack_public_path__ + "img/3.9e6efcd3.jpg";